import { Peer } from "@/webrtc/peer";

import { errorMessage } from "../actions/messages.actions";
import { resetWebRTC } from "../slices/webrtc-slice";

import { startCameraStreaming } from "./camera/camera-effects";

const { slices } = require("@/constants/sliceNames");
const { createAsyncThunk } = require("@reduxjs/toolkit");

export const connectWebRTC = createAsyncThunk(
  `${slices.webrtc}/connect`,
  async ({ cameraId, cameraName }, { dispatch }) => {
    try {
      const peer = new Peer(cameraId).connect(
        async (token) =>
          (await dispatch(startCameraStreaming({ cameraId: cameraId, cameraName, localSDPToken: token }))).payload
      );
      return {
        peer,
      };
    } catch (error) {
      dispatch(errorMessage(error.message ?? error.response?.data.message));
    }
  }
);

export const connectWebRTCStatuses = {
  [connectWebRTC.pending]: (state) => {
    state.loading = true;
  },
  [connectWebRTC.fulfilled]: (state, action) => {
    let { peer } = action.payload;
    state.peers[peer.id] = peer;
    state.loading = false;
    state.isConnected = true;
  },
  [connectWebRTC.rejected]: (state) => {
    state.loading = false;
  },
};

export const disconnectWebRTC = createAsyncThunk(
  `${slices.webrtc}/disconnect`,
  async (cameraId, { dispatch, getState }) => {
    const webrtc = getState()[slices.webrtc];
    if (webrtc.peers[cameraId]) {
      /**@type {Peer} */
      webrtc.peers[cameraId].disconnect();
    }
    await dispatch(resetWebRTC());
    return;
  }
);

export const disconnectWebRTCStatuses = {
  [disconnectWebRTC.pending]: (state) => {
    state.loading = true;
  },
  [disconnectWebRTC.fulfilled]: (state) => {
    state.loading = false;
    state.isConnected = false;
  },
  [disconnectWebRTC.rejected]: (state) => {
    state.loading = false;
    state.streams = {};
  },
};

export const startWebRTCSession = createAsyncThunk(
  `${slices.webrtc}/startWebRTCSession`,
  async ({ remoteSDP, cameraId }, { getState }) => {
    let webrtc = getState()[slices.webrtc].webrtc[cameraId];
    await webrtc.startSession(remoteSDP);
  }
);

export const startWebRTCSessionStatuses = {
  [startWebRTCSession.fulfilled]: () => {},
  [startWebRTCSession.pending]: () => {},
  [startWebRTCSession.rejected]: () => {},
};
